import ProcessTracker from '@/pages/components/ProcessTracker.vue';
import { setAuthorization, removeAuthorization } from '@/utils/request';
export default {
  components: {
    ProcessTracker: ProcessTracker
  },
  data: function data() {
    return {
      procInsId: ''
    };
  },
  mounted: function mounted() {
    var _this$$route$query = this.$route.query,
      procInsId = _this$$route$query.procInsId,
      mobileToken = _this$$route$query.mobileToken;
    this.procInsId = procInsId;
    sessionStorage.removeItem('token');
    removeAuthorization('Bearer');
    sessionStorage.setItem('token', mobileToken);
    setAuthorization(mobileToken);
  }
};